import { lazy } from 'react';

export const PlayerRiskLevelForm = lazy(() => import('./PlayerRiskLevelForm'));
